import React, { useState } from "react";

import "bootstrap-daterangepicker/daterangepicker.css";

import "bootstrap-daterangepicker/daterangepicker.css";
import Moment from "moment/moment";
import DateRangePicker from "react-bootstrap-daterangepicker";

export const DateRange = ({ onChange, startDate, endDate }) => {
  const [dateRangeCurrentWeek, setDateRangeCurrentWeek] = useState(
    Moment(startDate).format("D MMM YYYY") +
      " - " +
      Moment(endDate).format("D MMM YYYY")
  );

  function handleDateApplyEvent(event, picker) {
    var startDate = picker.startDate;
    var endDate = picker.endDate;
    var gap = endDate.diff(startDate, "days");
    var currentWeek =
      startDate.format("D MMM YYYY") + " - " + endDate.format("D MMM YYYY");
    setDateRangeCurrentWeek(currentWeek);

    onChange(startDate, endDate);
  }

  return (
    <DateRangePicker
      startDate={startDate}
      endDate={endDate}
      onApply={handleDateApplyEvent}
    >
      <button
        className="btn btn-outline-theme btn-sm text-truncate me-3 mb-2 mb-sm-0"
        style={{ width: "100%" }}
      >
        <i className="fa fa-fw fa-calendar me-1"></i>
        <span>{startDate ? dateRangeCurrentWeek : "- Filter Date -"}</span>
        <i className="fa fa-fw fa-caret-down me-n1"></i>
      </button>
    </DateRangePicker>
  );
};
